var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_sms-edit",
    "data-name": "vuesax/linear/sms-edit",
    transform: "translate(-748 -250)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sms-edit",
    transform: "translate(748 250)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.5,38.25H11.25C4.5,38.25,0,34.875,0,27V11.25C0,3.375,4.5,0,11.25,0h22.5C40.5,0,45,3.375,45,11.25V18",
    transform: "translate(4.5 7.875)",
    fill: "none",
    stroke: "#c32bd6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M22.5,0,15.457,5.625a7.123,7.123,0,0,1-8.438,0L0,0",
    transform: "translate(15.75 20.25)",
    fill: "none",
    stroke: "#c32bd6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(34.135 31.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M9.088,1.289,1.123,9.254a2.773,2.773,0,0,0-.675,1.327L.021,13.619a1.428,1.428,0,0,0,1.71,1.71L4.768,14.9A2.676,2.676,0,0,0,6.1,14.227l7.965-7.965c1.373-1.373,2.025-2.97,0-5C12.058-.736,10.461-.083,9.088,1.289Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#c32bd6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0A7.167,7.167,0,0,0,5,5",
    transform: "translate(7.941 2.437)",
    fill: "none",
    stroke: "#c32bd6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H54V54H0Z",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.5230b8a6502a0681a3561dd7528be923.svg";
export { ForwardRef as ReactComponent };